module.exports = new __parcel__URL__("settings.b1da4df8.svg").toString();